import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=bf079e74&"
import script from "./NotificationItem.vue?vue&type=script&setup=true&lang=ts&"
export * from "./NotificationItem.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports